// extracted by mini-css-extract-plugin
export default {"mainImg":"BigImgInput_mainImg__epgHp","delete":"BigImgInput_delete__I-ESh","bigButton":"BigImgInput_bigButton__mPwTw","spanContainer":"BigImgInput_spanContainer__yKj4L"};